import React, { useEffect, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import RenameConfirmationHeader from "./Rename/RenameConfirmationHeader";
import RenameConfirmationSecondaryHeader from "./Rename/RenameConfirmationSecondaryHeader";
import RenameConfirmationRequestProgress from "./Rename/RenameConfirmationRequestProgress";
import RenameConfirmationFlightDetails from "./Rename/RenameConfirmationFlightDetails";
import RenameConfirmationOrderIdContainer from "./Rename/RenameConfirmationOrderIdContainer";
import RenameConfirmationPriceBreakdown from "./Rename/RenameConfirmationPriceBreakdown";
import RenameConfirmationPassengers from "./Rename/RenameConfirmationPassengers";
import RenameConfirmationRemarks from "./Rename/RenameConfirmationRemarks";
import TicketManagementConfirmationContact from "./Common/TicketManagementConfirmationContact";
import TicketManagementConfirmationFareRules from "./Common/TicketManagementConfirmationFareRules";
import RenameConfirmationRemarksSection from "./Rename/RenameConfirmationRemarksSection";
import RenameConfirmationRelevantFiles from "./Rename/RenameConfirmationRelevantFiles";

function TicketManagementFlightChangeNameConfirmationDetailsPage() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [data, setData] = useState();
  const [loading, setLoading] = useState();

  // useEffect(() => {
  //   if (data?.status) {
  //     if (data?.status !== "Success") {
  //       navigate(`/order/flight/ticket/Rename/confirmation/${id}`, {
  //         replace: true,
  //       });
  //     }
  //   }
  // }, [data?.status]);

  return (
    <div className="w-full flex flex-col items-center bg-background min-h-screen">
      <div className="flex flex-col w-full max-w-7xl items-center pb-10">
        <div
          className={`w-full flex flex-col items-center max-w-7xl gap-4 mt-4 px-3 lg:px-6 py-6 `}
        >
          <RenameConfirmationHeader
            data={data}
            setData={setData}
            loading={loading}
            setLoading={setLoading}
          />
          {loading ? (
            <div className="w-full py-4 flex items-center justify-center">
              <div className="primaryLoader"></div>
            </div>
          ) : (
            <div className="flex flex-col w-full">
              <RenameConfirmationSecondaryHeader data={data} />
              <RenameConfirmationRequestProgress data={data} />
              <div className="flex w-full gap-4 lg:gap-6 flex-col lg:flex-row relative">
                <div className="flex flex-col flex-1">
                  <RenameConfirmationOrderIdContainer data={data} />
                  <div className="w-full flex lg:hidden">
                    <RenameConfirmationPriceBreakdown data={data} />
                  </div>
                  <RenameConfirmationFlightDetails data={data} />
                  <TicketManagementConfirmationFareRules data={data} />
                  <RenameConfirmationPassengers data={data} />
                  <RenameConfirmationRelevantFiles data={data} />
                  <RenameConfirmationRemarksSection data={data} />
                  <TicketManagementConfirmationContact />
                  <RenameConfirmationRemarks />
                </div>
                <div className="lg:max-w-[350px] w-full hidden lg:flex">
                  <RenameConfirmationPriceBreakdown data={data} />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default TicketManagementFlightChangeNameConfirmationDetailsPage;
